/**
 * Drags you start by touch on an iPhone (audit 2026-11-02, #42).
 *
 * iPhone Safari starts a native HTML5 drag from a long press, but it ends the
 * drag at once when the drag carries no data. Most of the app's reorder rows
 * only record which row was picked up (in state or a ref) and never call
 * `dataTransfer.setData`, so on a phone the row lifted and fell back with no
 * drop, and the page scrolled instead. A computer's browser does not mind.
 *
 * One listener on the document, after every row's own handler has run, gives
 * such a drag a plain-text placeholder. A handler that set its own data is
 * left alone. Tested in iPhone Safari on the attribute list.
 */
export const TOUCH_DRAG_PLACEHOLDER = 'priorities-drag';

export function addPlaceholderDragData(event: Pick<DragEvent, 'dataTransfer'>): boolean {
  const dt = event.dataTransfer;
  if (!dt || dt.types.length > 0) return false;
  dt.setData('text/plain', TOUCH_DRAG_PLACEHOLDER);
  return true;
}

let installed = false;

export function installTouchDragData(target: Pick<Document, 'addEventListener'> = document): void {
  if (installed) return;
  installed = true;
  // Bubble phase on the document: React's own onDragStart (on the root) runs first.
  target.addEventListener('dragstart', (e) => addPlaceholderDragData(e as DragEvent));
}
